import React, { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { LabeledCheckbox } from 'components/shared/checkbox';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import InfoTooltip from 'components/shared/InfoTooltip';
import DebouncedTextArea from 'components/shared/debouncedTextArea';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';

const GraderNotes = ({
  contentId,
  comments,
  handleCommentUpdate,
  updateGradable,
  onChange,
}) => {
  const [commentValue, setCommentValue] = useState(
    comments.find(e => e.commentType === 'note_to_grader')?.comment?.trim(),
  );
  const [isChecked, setIsChecked] = useState(
    comments?.length !== 0 &&
      comments.find(comment => comment.commentType === 'note_to_grader')
        ?.active,
  );
  const [defaultCheck, setDefaultCheck] = useState(false);
  const [showTextBox, setShowTextBox] = useState(isChecked && !defaultCheck);

  useEffect(() => {
    if (!isChecked) {
      setDefaultCheck(false);
    }
    if (isChecked && defaultCheck && !commentValue) {
      setIsChecked(false);
      setShowTextBox(false);
    }
    if (isChecked) {
      updateGradable();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commentValue, isChecked]);

  const onChangeGraderNotes = async e => {
    try {
      await request
        .postJSON(routes.EDITOR.ASSOCIATED_COMMENTS(contentId), {
          comment: commentValue?.trim() || '',
          comment_type: 'note_to_grader',
          active: e.target.checked,
        })
        .then(
          handleCommentUpdate({
            commentType: 'note_to_grader',
            comment: commentValue?.trim() || '',
            active: e.target.checked,
          }),
          setIsChecked(e.target.checked),
          setShowTextBox(prev => !prev),
        );
    } catch (error) {
      console.error(error);
    }
    onChange({ unused_property: true });
  };

  const updateComment = async comment => {
    setDefaultCheck(true);
    setCommentValue(comment);
    try {
      await request
        .postJSON(routes.EDITOR.ASSOCIATED_COMMENTS(contentId), {
          comment: comment ? comment.trim() : '',
          comment_type: 'note_to_grader',
          active: comment !== '',
        })
        .then(
          handleCommentUpdate({
            commentType: 'note_to_grader',
            comment: comment ? comment.trim() : '',
            active: comment !== '',
          }),
        );
    } catch (error) {
      console.error(error);
    }
    onChange({ unused_property: true });
  };

  return (
    <>
      <LabeledCheckbox
        className="EditorElement-options w-fc"
        checkBoxClassName="va-m h-18 w-18 mr-12-imp"
        label={
          <>
            <Text variant={TEXT_VARIANTS.BODY} className="as-b">
              {t('questions.answer_key.grader_notes.title')}
            </Text>
            {isChecked && (
              <>
                <span className="c-danger-red"> * </span>
              </>
            )}
            <InfoTooltip
              className="pl-4 mt-4 tooltip-fixedWidth c-gray-light"
              tooltip={t('questions.answer_key.grader_notes.info_tooltip')}
            />
          </>
        }
        onChange={e => onChangeGraderNotes(e)}
        checked={isChecked}
      />
      <CSSTransition
        appear
        classNames="slider"
        in={showTextBox}
        timeout={500}
        unmountOnExit
        onExited={() => setShowTextBox(false)}
      >
        <div className="slider">
          <DebouncedTextArea
            className="EditorElement-input EditorElement-input--single EditorElement-input--answer-key ml-35"
            id={`grader-notes-correct-answer-${contentId}`}
            onChange={value => {
              updateComment(value);
            }}
            placeholder={t('questions.answer_key.grader_notes.placeholder')}
            value={commentValue}
          />
        </div>
      </CSSTransition>
    </>
  );
};

export default GraderNotes;
